import * as React from 'react';
import type { SVGIconProps } from './Icon.types';

const StarIcon = React.forwardRef<SVGSVGElement, SVGIconProps>(({ color = 'currentColor', ...props }, forwardedRef) => {
  return (
    <svg
      fill="none"
      height="24"
      ref={forwardedRef}
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props.title}</title>
      <path
        d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26ZM12.0006 15.968L16.2473 18.3451L15.2988 13.5717L18.8719 10.2674L14.039 9.69434L12.0006 5.27502L9.96214 9.69434L5.12921 10.2674L8.70231 13.5717L7.75383 18.3451L12.0006 15.968Z"
        fill={color}
      />
    </svg>
  );
});

export default StarIcon;
